/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react';// eslint-disable-line no-unused-vars
import styles from './App.scss';
import baseComponent from '../../decorators/baseComponent';
import BaseReactComponent from '../Util/BaseReactComponent';

@baseComponent(styles) class App extends BaseReactComponent {

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// /src/components/App/App.js